module.exports = __webpack_public_path__ + "static/img/next_button.0662b621.png";